import React from 'react';
import PropTypes from 'prop-types';

import Container from '../Container';
import Desktop from '../../../../components/Responsive/Desktop';
import Tablet from '../../../../components/Responsive/Tablet';
import Mobile from '../../../../components/Responsive/Mobile';
import Banner from '../Banner';

const BannerContainer = ({
    data: {
        AltText,
        DesktopViewImg,
        DesktopViewLink,
        TabletViewImg,
        TabletViewLink,
        MobileViewImg,
        MobileViewLink,
    },
    extendClass,
}) => (
    <Container>
        <Desktop>
            {DesktopViewImg && (
                <Banner
                    extendClass={extendClass}
                    link={DesktopViewLink}
                    img={DesktopViewImg}
                    altText={AltText}
                />
            )}
        </Desktop>

        <Tablet>
            {TabletViewImg && (
                <Banner link={TabletViewLink} img={TabletViewImg} altText={AltText} />
            )}
        </Tablet>

        <Mobile>
            {MobileViewImg && (
                <Banner link={MobileViewLink} img={MobileViewImg} altText={AltText} />
            )}
        </Mobile>
    </Container>
);

BannerContainer.propTypes = {
    data: PropTypes.objectOf(PropTypes.string.isRequired),
    extendClass: PropTypes.string,
};

export default BannerContainer;
